
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    exts: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    exts_text() {
      return this.exts.join(', ')
    }
  }
}
